import * as React from 'react';
import { provideDisplayName } from '../utils';
import { jsx as _jsx } from "react/jsx-runtime";
export default function sortableHandle(WrappedComponent) {
  var _class;

  return _class = class WithSortableHandle extends React.Component {
    constructor(...args) {
      super(...args);
      this.wrappedInstance = /*#__PURE__*/React.createRef();
    }

    componentDidMount() {
      this.wrappedInstance.current.sortableHandle = true;
    }

    getWrappedInstance() {
      return this.wrappedInstance.current;
    }

    render() {
      return /*#__PURE__*/_jsx(WrappedComponent, {
        ref: this.wrappedInstance,
        ...this.props
      });
    }

  }, _class.displayName = provideDisplayName('sortableHandle', WrappedComponent), _class;
}
export function isSortableHandle(node) {
  return node.sortableHandle != null;
}